import { render, staticRenderFns } from "./FaixaEtariaCard.vue?vue&type=template&id=8ec9da7a&scoped=true"
import script from "./FaixaEtariaCard.vue?vue&type=script&lang=js"
export * from "./FaixaEtariaCard.vue?vue&type=script&lang=js"
import style0 from "./FaixaEtariaCard.vue?vue&type=style&index=0&id=8ec9da7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec9da7a",
  null
  
)

export default component.exports